import { Flex, Text, Button } from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { useColorMode } from "@chakra-ui/color-mode";
import { useAppContext } from "../AppContext";

export const Theme = (): JSX.Element => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { isEnglish } = useAppContext();

  const switchToDarkMode = () => {
    if (colorMode === "light") {
      toggleColorMode();
    }
  };

  const switchToLightMode = () => {
    if (colorMode === "dark") {
      toggleColorMode();
    }
  };

  return (
    <Flex align="center" justify="space-between">
      <Text fontSize="lg" as="b">
        {isEnglish ? `Theme:` : "主題："}
      </Text>
      <Flex gap={"10px"}>
        <Button
          w="95px"
          leftIcon={<MoonIcon color={colorMode === "dark" ? "blue.700" : "gray.400"} />}
          onClick={switchToDarkMode}
          colorScheme={colorMode === "dark" ? "blue" : "gray"}
        >
          {isEnglish ? "Dark" : "深色"}
        </Button>
        <Button
          w="95px"
          leftIcon={<SunIcon color={colorMode === "light" ? "orange.400" : "gray.400"} />}
          onClick={switchToLightMode}
          colorScheme={colorMode === "light" ? "yellow" : "gray"}
          bg={colorMode === "light" ? "yellow.200" : undefined}
          _hover={{
            bg: colorMode === "light" ? "yellow.300" : "gray.200",
          }}
        >
          {isEnglish ? "Light" : "淺色"}
        </Button>
      </Flex>
    </Flex>
  );
};
